import { mixed, object, SchemaOf } from 'yup';

import { REQUIRED_FIELD } from '@/config/text.const';
import { ImportingToolUploadFields } from '../hooks/useImportingToolUploadDocument';

export const ALLOWED_FILE_EXTENSIONS = ['csv'];

export const validationSchema: SchemaOf<ImportingToolUploadFields> = object().shape({
  file: mixed()
    .test((value, context) => {
      if (!value || value instanceof File) {
        return true;
      }

      return context.createError({
        path: 'file',
        message: 'Invalid file'
      });
    })
    .test((value: File, context) => {
      const isAllowedExtension = ALLOWED_FILE_EXTENSIONS.some((ext) => {
        return value?.name?.endsWith(ext);
      });

      if (!value || isAllowedExtension) {
        return true;
      }

      return context.createError({
        path: 'file',
        message: 'Invalid file extension'
      });
    })
    .required(REQUIRED_FIELD)
});
